import { bold, cyan } from './ansiHelpers.js';

/**
 * Formats a package name and version.
 */
export function formatPackageName({ name, version }: { name?: string; version?: string }): string {
  return `${bold(cyan(name))}${cyan(`@${version}`)}`;
}
